/* Stijlen voor de Shadow DOM van de embed. Mobile-first; HG-huisstijl (Nunito, terracotta, pill-knoppen). */

:host {
  all: initial;
  display: block;
  --aps-accent: #d67e60;
  --aps-accent-press: #bf6649;
  --aps-accent-soft: #fbeee8;
  --aps-ink: #262626;
  --aps-muted: #6f6763;
  --aps-line: #eee3de;
  --aps-cream: #fff8f4;
  --aps-cta-border: #f2d9cf;
  --aps-cta-end: #fcebe3;
  --aps-glow: 214, 126, 96;
  --aps-progress: #eaa88f;
  --aps-track: #f3e7e1;
  --aps-spinner: #f3e1d9;
  --aps-green: #2f7d5b;
  --aps-green-soft: #eef8f2;
  --aps-font: Nunito, ui-rounded, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --aps-heading: 'Venti SemiBold', Nunito, system-ui, sans-serif;
  font-family: var(--aps-font);
  font-size: 16px;
  line-height: 1.4;
  color: var(--aps-ink);
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

button {
  font: inherit;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
}

/* ------------------------------------------------------------------ CTA op de PDP */

.cta {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 78px;
  margin: 10px 0 16px;
  padding: 12px 14px 12px 12px;
  border: 1.5px solid var(--aps-cta-border);
  border-radius: 0.5rem;
  background: linear-gradient(135deg, var(--aps-cream) 0%, var(--aps-cta-end) 100%);
  text-align: left;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(var(--aps-glow), 0.08);
  transition:
    transform 0.12s ease,
    box-shadow 0.2s ease;
}

.cta:hover {
  box-shadow: 0 6px 18px rgba(var(--aps-glow), 0.18);
}

.cta:active {
  transform: scale(0.985);
}

.cta:focus-visible,
.btn:focus-visible,
.icon-btn:focus-visible,
.link:focus-visible,
.compare:focus-visible {
  outline: 3px solid rgba(var(--aps-glow), 0.5);
  outline-offset: 2px;
}

.cta__art {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  display: block;
}

.cta__art img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cta__text {
  flex: 1;
  min-width: 0;
}

.cta__title {
  display: block;
  font-weight: 800;
  font-size: 16px;
  line-height: 1.25;
}

.cta__sub {
  display: block;
  margin-top: 3px;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 500;
  color: var(--aps-muted);
}

.cta__chev {
  flex: 0 0 auto;
  color: var(--aps-accent);
}

.badge {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--aps-accent);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: 2px;
}

.badge--ribbon {
  position: absolute;
  top: -10px;
  right: 16px;
  margin: 0;
  box-shadow: 0 2px 6px rgba(var(--aps-glow), 0.35);
}

.cta--applied {
  border-color: #cfe8db;
  background: linear-gradient(135deg, #f6fcf8 0%, #eaf6ef 100%);
}

.cta--applied .badge {
  background: var(--aps-green);
}

/* ------------------------------------------------------------------ modal / sheet */

.overlay {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(33, 26, 23, 0.5);
  animation: aps-fade 0.2s ease both;
}

.sheet {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100dvh;
  background: #fff;
  outline: none;
  animation: aps-up 0.32s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@media (min-width: 640px) {
  .overlay {
    align-items: center;
    padding: 24px;
  }

  .sheet {
    max-width: 520px;
    height: auto;
    max-height: min(92dvh, 820px);
    border-radius: 24px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
    overflow: hidden;
  }

  .sheet.sheet--wide {
    max-width: 880px;
  }
}

.head {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 60px;
  padding: max(8px, env(safe-area-inset-top)) 8px 8px 20px;
  border-bottom: 1px solid var(--aps-line);
}

.head__title {
  flex: 1;
  margin: 0;
  font-family: var(--aps-heading);
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
}

.head--intro {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
}

.head--intro .head__title {
  text-align: center;
}

.head__balance {
  justify-self: end;
  width: 108px;
}

.btn-cancel {
  justify-self: start;
  min-height: 40px;
  padding: 0 14px;
  border: 1.5px solid var(--aps-line);
  border-radius: 999px;
  background: #fff;
  font-weight: 800;
  cursor: pointer;
}

.icon-btn {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.icon-btn:active {
  background: #f6efec;
}

.body {
  flex: 1;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 20px;
}

.foot {
  display: grid;
  gap: 8px;
  padding: 12px 20px calc(14px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--aps-line);
  background: #fff;
}

.foot__pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 52px;
  padding: 0 20px;
  border: 0;
  border-radius: 100px;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  transition:
    transform 0.1s ease,
    background-color 0.15s ease;
}

.btn:active {
  transform: scale(0.98);
}

.btn--primary {
  background: var(--aps-accent);
  color: #fff;
}

.btn--primary:active {
  background: var(--aps-accent-press);
}

.btn--ghost {
  background: #fff;
  color: var(--aps-ink);
  box-shadow: inset 0 0 0 1.5px var(--aps-line);
}

.btn[disabled] {
  opacity: 0.6;
  cursor: default;
}

.link {
  justify-self: center;
  min-height: 44px;
  padding: 0 12px;
  border: 0;
  background: none;
  color: var(--aps-accent-press);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

/* ------------------------------------------------------------------ stap: intro */

.hero {
  display: grid;
  place-items: center;
  padding: 16px 12px;
  border-radius: 20px;
  background: var(--aps-cream);
}

.hero svg {
  width: 100%;
  max-width: 320px;
  height: auto;
}

.lead {
  margin: 18px 0 0;
  font-size: 16px;
  line-height: 1.5;
}

.tips {
  display: grid;
  gap: 10px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.tips li {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  font-size: 15px;
  line-height: 1.45;
  color: var(--aps-ink);
}

.tips svg {
  color: var(--aps-accent);
  margin-top: 1px;
}

.fine {
  display: flex;
  gap: 8px;
  margin: 16px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--aps-muted);
}

.fine svg {
  flex: 0 0 16px;
  margin-top: 1px;
}

.intro-grid {
  display: grid;
  gap: 16px;
}

.tips-panel {
  padding: 16px;
  border-radius: 20px;
  background: #f4f7fb;
}

.tips-panel h3,
.tips-panel p,
.library__title,
.library__note {
  margin: 0;
  text-align: left;
}

.tips-panel h3,
.library__title {
  font-size: 16px;
  line-height: 1.35;
}

.tips-panel .panel-name {
  margin-bottom: 8px;
  color: var(--aps-muted);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.tips-panel .panel-copy {
  margin-top: 6px;
  color: var(--aps-ink);
  font-size: 15px;
  line-height: 1.45;
}

.tips-panel .tips-heading {
  margin-top: 16px;
}

.tips-panel .fine {
  margin-top: 16px;
}

.library__note {
  margin: 0 0 10px;
  color: var(--aps-muted);
  font-size: 14px;
  line-height: 1.4;
}

.tips-panel .hero {
  margin-bottom: 14px;
  padding: 8px;
  background: #fff;
}

.drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 240px;
  padding: 20px;
  border: 1.5px dashed #d5d0dc;
  border-radius: 20px;
  background: #fafafa;
  text-align: center;
}

.drop__icon {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ece7f8;
  color: #5b4b8a;
}

.drop__meta {
  margin: 0;
  max-width: 26ch;
  color: var(--aps-muted);
  font-size: 14px;
  line-height: 1.4;
}

.library {
  margin-top: 18px;
}

.library__row {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.library__card {
  display: flex;
  flex: 0 0 148px;
  flex-direction: column;
  gap: 8px;
}

.library__card img {
  width: 100%;
  height: 108px;
  object-fit: cover;
  border-radius: 14px;
  background: var(--aps-cream);
}

.library__label {
  font-size: 13px;
  font-weight: 800;
}

.fixed-example {
  display: block;
  width: 100%;
  max-height: 220px;
  margin-top: 12px;
  object-fit: contain;
  border-radius: 12px;
}

.style-photo {
  display: grid;
  place-items: center;
  margin-bottom: 16px;
}

.style-photo img {
  max-height: 120px;
  max-width: 100%;
  border-radius: 16px;
  object-fit: contain;
}

.style-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.style-card {
  display: grid;
  grid-template-columns: 104px 1fr;
  gap: 12px;
  align-items: center;
  padding: 8px;
  border: 1.5px solid var(--aps-line);
  border-radius: 16px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.style-card img {
  width: 104px;
  height: 104px;
  object-fit: contain;
  border-radius: 12px;
  display: block;
}

.style-card__text {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.style-card b {
  font-size: 16px;
}

.style-card__text span {
  color: var(--aps-muted);
  font-size: 14px;
  line-height: 1.35;
}

.style-card:hover,
.style-card:active {
  background: var(--aps-accent-soft);
}

@media (min-width: 640px) {
  .intro-grid {
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
  }

  .style-grid {
    grid-template-columns: 1fr 1fr;
  }

  .style-card {
    grid-template-columns: 132px 1fr;
  }

  .style-card img {
    width: 132px;
    height: 132px;
  }
}

/* hergebruik van een eerder gemaakte aquarel */
.reuse {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 12px;
  border-radius: 20px;
  background: var(--aps-green-soft);
  border: 1.5px solid #cfe8db;
}

.reuse img {
  flex: 0 0 96px;
  width: 96px;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  background: #fff;
}

.reuse__text {
  display: grid;
  gap: 4px;
  font-size: 14px;
  line-height: 1.35;
}

.reuse__text b {
  font-size: 16px;
}

.reuse__text span {
  color: var(--aps-muted);
}

.btn--sm {
  min-height: 44px;
  margin-top: 6px;
  font-size: 15px;
}

/* ------------------------------------------------------------------ stap: bezig */

.stage {
  position: relative;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 20px;
  background: #f4eeea;
}

.stage img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: min(52dvh, 440px);
  object-fit: contain;
  filter: saturate(0.8) brightness(1.03);
}

.wash {
  position: absolute;
  inset: -20%;
  background:
    radial-gradient(40% 35% at 30% 30%, rgba(var(--aps-glow), 0.45), transparent 70%),
    radial-gradient(35% 30% at 72% 58%, rgba(120, 170, 205, 0.45), transparent 70%),
    radial-gradient(30% 30% at 40% 82%, rgba(240, 200, 120, 0.45), transparent 70%);
  mix-blend-mode: soft-light;
  filter: blur(10px);
  animation: aps-wash 5s ease-in-out infinite alternate;
}

.shine {
  position: absolute;
  inset: 0;
  background: linear-gradient(100deg, transparent 30%, rgba(255, 255, 255, 0.5) 50%, transparent 70%);
  transform: translateX(-100%);
  animation: aps-shine 2.4s ease-in-out infinite;
}

.status {
  min-height: 1.4em;
  margin: 18px 0 10px;
  font-weight: 800;
  font-size: 17px;
  text-align: center;
}

.progress {
  height: 8px;
  overflow: hidden;
  border-radius: 99px;
  background: var(--aps-track);
}

.progress > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--aps-progress), var(--aps-accent));
  transition: width 0.6s ease;
}

.progress-label {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
  color: var(--aps-muted);
}

.hint {
  margin: 10px 0 0;
  font-size: 14px;
  text-align: center;
  color: var(--aps-muted);
}

.spinner {
  width: 44px;
  height: 44px;
  margin: 40px auto 16px;
  border: 4px solid var(--aps-spinner);
  border-top-color: var(--aps-accent);
  border-radius: 50%;
  animation: aps-spin 0.9s linear infinite;
}

.center {
  text-align: center;
}

/* ------------------------------------------------------------------ stap: vergelijken */

.compare {
  position: relative;
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 20px;
  background: #f4eeea;
  touch-action: pan-y;
  user-select: none;
  -webkit-user-select: none;
  cursor: ew-resize;
}

.compare img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  -webkit-user-drag: none;
}

.compare__handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 0;
}

.compare__line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -1px;
  width: 2px;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.compare__knob {
  position: absolute;
  top: 50%;
  left: 0;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  margin: -22px 0 0 -22px;
  border-radius: 50%;
  background: #fff;
  color: var(--aps-accent);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.chip {
  position: absolute;
  top: 12px;
  padding: 4px 10px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.chip--l {
  left: 12px;
}

.chip--r {
  right: 12px;
  max-width: calc(100% - 80px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compare-hint {
  margin: 12px 0 0;
  font-size: 14px;
  text-align: center;
  color: var(--aps-muted);
}

/* ------------------------------------------------------------------ stap: klaar */

.success {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 14px;
  font-weight: 800;
  font-size: 17px;
  color: var(--aps-green);
}

.card-shot {
  display: grid;
  place-items: center;
  padding: 18px;
  border-radius: 20px;
  background: var(--aps-cream);
}

.card-shot img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 280px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(84, 52, 40, 0.18);
}

.card-shot img.loading {
  opacity: 0.4;
  width: 100%;
  min-height: 160px;
}

/* ------------------------------------------------------------------ fout */

.err {
  padding: 12px 4px;
  text-align: center;
}

.err__icon {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin: 8px auto 14px;
  border-radius: 50%;
  background: var(--aps-accent-soft);
  color: var(--aps-accent);
}

.err h3 {
  margin: 0 0 8px;
  font-family: var(--aps-heading);
  font-weight: 600;
  font-size: 20px;
}

.err p {
  margin: 0;
  line-height: 1.5;
  color: var(--aps-muted);
}

/* ------------------------------------------------------------------ animaties */

@keyframes aps-fade {
  from {
    opacity: 0;
  }
}

@keyframes aps-up {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
}

@keyframes aps-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes aps-wash {
  0% {
    transform: translate(-4%, -2%) rotate(0deg);
  }
  100% {
    transform: translate(4%, 3%) rotate(8deg);
  }
}

@keyframes aps-shine {
  0% {
    transform: translateX(-100%);
  }
  60%,
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
